import React from 'react';
import Form from '../Form';
import Input from '../Form/Input';
import Textarea from '../Form/Textarea';
import Radio from '../Form/Radio';

import styles from './RSVP.module.scss';

import db from '../../firebase';
import { collection, addDoc } from "firebase/firestore"; 
import emailjs from '@emailjs/browser';
import GoogleCalendarButton from 'components/GoogleCalendarButton/GoogleCalendarButton';

const menu = [
    { label: 'Свинско', id: 'Свинско' },
    { label: 'Пилешко', id: 'Пилешко' },
    { label: 'Вегетарианско', id: 'Вегетарианско' },
  ];


const RSVP = () => {
    const form = Form.useForm({menu: 'Свинско'});

    const sendEmail = (data) => {
        const emailData = {
            name: `${data.fname} ${data.lname}`,
            time: new Date().toLocaleString(),
            title: `${data.fname} ${data.lname} ${data.attend === 'yes' ? 'ще присъства' : 'няма да присъства'}`,
            attend: data.attend === 'yes' ? "Ще присъства" : "Няма да присъства",
            menu: data.menu,
            message:data.message
        }

        try {
            emailjs
            .send('service_ct1th0m', 'template_gdrd7q9', emailData, {
                publicKey: 'Rm1rUZUuOaPZHxxJh',
            })
        } catch {}
    };

    const onSubmit = async (data) => {
        sendEmail(data);
        addDoc(collection(db, "guests"), data);
    }

    return (
        <>
            <Form form={form} onSubmit={onSubmit}>
                <div className={styles.groupFields}>
                    <Input label="Име" name="fname" required />
                    <Input label="Фамилия" name="lname" required />
                </div>
                <div className={styles.groupFields}>
                    <Radio label="Ще присъствам" id="yes" name="attend" required />
                    <Radio label="Няма да присъствам" id="no" name="attend" required />
                </div>

                <Radio.Group label="Избери меню">
                    {menu.map(item => <Radio key={item.id} name="menu" {...item} />)}
                </Radio.Group>
                <Textarea label="Съобщение" name="message" />
            </Form>
        </>
    )
}

export default RSVP;